export const FETCH_SITES_SUCCESS = "FETCH_SITES_SUCCESS";
export const POST_SITES_SUCCESS = "POST_SITES_SUCCESS";
export const PUT_SITES_SUCCESS = "PUT_SITES_SUCCESS";
export const DELETE_SITES_SUCCESS = "DELETE_SITES_SUCCESS";
export const UPDATE_SITE_SUCCESS = "UPDATE_SITE_SUCCESS";
export const CLEAR_TYPE = "CLEAR_TYPE";
export const COMPLETE_SITES_SUCCESS = "COMPLETE_SITES_SUCCESS";
export const CHANGE_TYPE_LIST_SITES_SUCCESS = "CHANGE_TYPE_LIST_SITES_SUCCESS";